'use strict';

var i18n = require('i18next');
var EditOpenVpnEnabled = require('actions/vpn/enableOpenVpn/EditOpenVpnEnabled');
var FormView = require('actions/vpn/enableOpenVpn/FormView');
var StaticView = require('actions/vpn/enableOpenVpn/StaticView');

/**
 * Action configuration for the VPN enable/disable action component.
 */
module.exports = {
  title: i18n.t('vpn.enableOpenVpn.title'),
  Model: EditOpenVpnEnabled,
  FormView: FormView,
  TextView: StaticView,
};
